function sessionStorageTransfer(event: StorageEvent) {
	if (!event.newValue) return;
	if (event.key === 'getSessionStorage') {
		const data = {
			url: event.url,
			sessionStorage,
		};

		localStorage.setItem('sessionStorage', JSON.stringify(data));
		localStorage.removeItem('sessionStorage');
	} else if (event.key === 'sessionStorage' && !sessionStorage.length) {
		const data = JSON.parse(event.newValue);
		for (let i = 0, keys = Object.keys(data.sessionStorage); i < keys.length; i++) {
			sessionStorage.setItem(keys[i], data.sessionStorage[keys[i]]);
		}
		// eslint-disable-next-line no-restricted-globals
		history.replaceState({}, '', data.url);
		// eslint-disable-next-line no-restricted-globals
		history.go(0);
	}
}

export function initStorage() {
	if (window.addEventListener) {
		window.addEventListener('storage', sessionStorageTransfer, false);
	} else {
		window.onstorage = sessionStorageTransfer;
	}

	if (!sessionStorage.length) {
		localStorage.setItem('getSessionStorage', 'Trigger transfer.');
		localStorage.removeItem('getSessionStorage');
	}
}
